export const business_types = [
    {
       level1: 'Commercial',
       sub_levels: [
           {
               level2: 'Education',
               sub_levels: ['Adult Education', 'College / University', 'K-12 School', 'Pre-School / Daycare', 'Vocational School']
           },
           {
                level2: 'Healthcare',
                sub_levels: ['Ambulatory Surgical Center', 'Hospital', 'Medical Building', 'Medical Condominium', 
                'Outpatient Rehab / Physical Therapy', 'Residential Care Facility', 'Senior Care Facility', 
                'Urgent Care / Clinic / Other Outpatient']
           },
           {
                level2: 'Hospitality',
                sub_levels: ['Hotel', 'Hotel Condominium', 'Motel', 'Resort',
                'Restaurant', 'Transient Lodging']
           },
           {
                level2: 'Mixed Use',
                sub_levels: ['Commercial / Industrial', 'Hotel / Residential']
           },
           {
                level2: 'Office',
                sub_levels: ['Business Park', 'Financial Building', 'Office Building', 'Office Condominium']
           },
           {
                level2: 'Public Services',
                sub_levels: ['Courthouse', 'Drinking Water Treatment & Distribution', 'Fire Station', 'Library',
                'Mailing Center / Post Office', 'Prison / Correctional Facility', 'Social / Meeting Hall',
                'Transportation Terminal Station', 'Wastewater Treatment Plant', 'Other']
           },
           {
               level2: 'Retail',
               sub_levels: ['Automotive Repair Shop', 'Automotive Sales Dealership', 'Bar / Tavern / Nightclub', 'Bank Branch',
               'Beauty Salon', 'Car Wash', 'Convenience / Service Station', 'Department Store', 'Drug Store', 'Drycleaning',
               'Fast Food Restaurant', 'Financial Services', 'Health spa', 'Laundromat', 'Other Repair Services', 'Retail Store',
               'Shopping mall', 'Supermarket / Grocery Store', 'Wholesale Club / Supercenter']
           }
       ]
    },
    {
        level1: 'Industrial',
        sub_levels: [
            {
                level2: 'Aircraft Facility',
                sub_levels: []
            },
            {
                level2: 'Automotive Wrecking',
                sub_levels: []
            },
            {
                level2: 'Bulk Plant',
                sub_levels: []
            },
            {
                level2: 'Chemical',
                sub_levels: []
            },
            {
                level2: 'Dump Site',
                sub_levels: []
            },
            {
                level2: 'Facilities',
                sub_levels: []
            },
            {
                level2: 'Food Packing / Packing / Canning Plant',
                sub_levels: []
            },
            {
                level2: 'Gas Production',
                sub_levels: []
            },
            {
                level2: 'General Industrial',
                sub_levels: []
            },
            {
                level2: 'Heavy Industrial',
                sub_levels: []
            },
            {
                level2: 'Industrial Park',
                sub_levels: []
            },
            {
                level2: 'Industrial Plant',
                sub_levels: []
            },
            {
                level2: 'Light Industrial',
                sub_levels: []
            },
            {
                level2: 'Lumber Mill',
                sub_levels: []
            },
            {
                level2: 'Lumber Yard',
                sub_levels: []
            },
            {
                level2: 'Manufacturing Plant',
                sub_levels: []
            },
            {
                level2: 'Metal Production',
                sub_levels: []
            },
            {
                level2: 'Mine / Quarry',
                sub_levels: []
            },
            {
                level2: 'Mineral Processing',
                sub_levels: []
            },
            {
                level2: 'Paper & Allied Industry',
                sub_levels: []
            },
            {
                level2: 'Petroleum',
                sub_levels: []
            },
            {
                level2: 'Public Storage',
                sub_levels: []
            },
            {
                level2: 'Salvage',
                sub_levels: []
            },
            {
                level2: 'Shipyard',
                sub_levels: []
            },
            {
                level2: 'Storage (Temp Controlled)',
                sub_levels: []
            },
            {
                level2: 'Storage Tanks',
                sub_levels: []
            },
            {
                level2: 'Textile / Clothes / Carpet',
                sub_levels: []
            },
            {
                level2: 'Warehouse / Distribution Center',
                sub_levels: []
            },
            {
                level2: 'Waste Disposal',
                sub_levels: []
            },
            {
                level2: 'Well / Gas / Oil',
                sub_levels: []
            }
        ]
     },
     {
        level1: 'Multifamily',
        sub_levels: [
            {
                level2: 'Apartment Complex',
                sub_levels: []
            },
            {
                level2: 'Assisted Living',
                sub_levels: []
            },
            {
                level2: 'Condominium Complex',
                sub_levels: []
            },
            {
                level2: 'Cooperative',
                sub_levels: []
            },
            {
                level2: 'Dormitories / Group Quarters',
                sub_levels: []
            },
            {
                level2: 'Duplex',
                sub_levels: []
            },
            {
                level2: 'Fraternity / Sorority House',
                sub_levels: []
            },
            {
                level2: 'Memory Care',
                sub_levels: []
            },
            {
                level2: 'Mobile Home Park',
                sub_levels: []
            },
            {
                level2: 'Nursing Home',
                sub_levels: []
            },
            {
                level2: 'Quadplex',
                sub_levels: []
            },
            {
                level2: 'Triplex',
                sub_levels: []
            }
        ]
    },
    {
        level1: 'Special Purpose',
        sub_levels: [
            {
                level2: 'Amusement Park',
                sub_levels: []
            },
            {
                level2: 'Animal Hospital / Veterinarian',
                sub_levels: []
            },
            {
                level2: 'Arcade',
                sub_levels: []
            },
            {
                level2: 'Auditorium',
                sub_levels: []
            },
            {
                level2: 'Billiard Hall',
                sub_levels: []
            },
            {
                level2: 'Bowling Alley',
                sub_levels: []
            },
            {
                level2: 'Casino',
                sub_levels: []
            },
            {
                level2: 'Cemetery',
                sub_levels: []
            },
            {
                level2: 'Charitable Organization',
                sub_levels: []
            },
            {
                level2: 'Clubs, Lodges / Professional Associations',
                sub_levels: []
            },
            {
                level2: 'Communication Facility',
                sub_levels: []
            },
            {
                level2: 'Convalescent Hospital',
                sub_levels: []
            },
            {
                level2: 'Convention Center',
                sub_levels: []
            },
            {
                level2: 'Correctional Facility',
                sub_levels: []
            },
            {
                level2: 'Country Club',
                sub_levels: []
            },
            {
                level2: 'Dance Hall',
                sub_levels: []
            },
            {
                level2: 'Data Center',
                sub_levels: []
            },
            {
                level2: 'Funeral Home',
                sub_levels: []
            },
            {
                level2: 'Garage',
                sub_levels: []
            },
            {
                level2: 'Golf Course',
                sub_levels: []
            },
            {
                level2: 'Golf Range',
                sub_levels: []
            },
            {
                level2: 'Gym / Health / Spa / Fitness Club',
                sub_levels: []
            },
            {
                level2: 'Kennel',
                sub_levels: []
            },
            {
                level2: 'Laboratory',
                sub_levels: []
            },
            {
                level2: 'Marine',
                sub_levels: []
            },
            {
                level2: 'Marine Facility',
                sub_levels: []
            },
            {
                level2: 'Movie Theater',
                sub_levels: []
            },
            {
                level2: 'Museum',
                sub_levels: []
            },
            {
                level2: 'Native American Property',
                sub_levels: []
            },
            {
                level2: 'Nature Facility',
                sub_levels: []
            },
            {
                level2: 'Orphanage',
                sub_levels: []
            },
            {
                level2: 'PUD Common Space',
                sub_levels: []
            },
            {
                level2: 'Parking Lot',
                sub_levels: []
            },
            {
                level2: 'Parking Structure',
                sub_levels: []
            },
            {
                level2: 'Performing Arts',
                sub_levels: []
            },
            {
                level2: 'Port / Harbor',
                sub_levels: []
            },
            {
                level2: 'Recreation Center',
                sub_levels: []
            },
            {
                level2: 'R&D Facility / Laboratory',
                sub_levels: []
            },
            {
                level2: 'RV Park',
                sub_levels: []
            },
            {
                level2: 'Race Track',
                sub_levels: []
            },
            {
                level2: 'Racquet Court',
                sub_levels: []
            },
            {
                level2: 'Railroad Facility',
                sub_levels: []
            },
            {
                level2: 'Recording Studio',
                sub_levels: []
            },
            {
                level2: 'Religious Place of Worship',
                sub_levels: []
            },
            {
                level2: 'Skating Park',
                sub_levels: []
            },
            {
                level2: 'Stadium',
                sub_levels: []
            },
            {
                level2: 'Surgery Center',
                sub_levels: []
            },
            {
                level2: 'Swimming Pool',
                sub_levels: []
            },
            {
                level2: 'TV Facility',
                sub_levels: []
            },
            {
                level2: 'Tennis Club',
                sub_levels: []
            },
            {
                level2: 'Theater',
                sub_levels: []
            },
            {
                level2: 'Tourist Attraction',
                sub_levels: []
            }
        ]
    }
]